// extracted by mini-css-extract-plugin
export var askAiIcon = "_s5-9";
export var container = "_s5-0";
export var groupSeparator = "_s5-a";
export var highlight = "_s5-4";
export var resultIcon = "_s5-5";
export var resultItem = "_s5-7";
export var resultSubtitle = "_s5-3";
export var resultTitle = "_s5-2";
export var resultsList = "_s5-1";
export var searchGroup = "_s5-6";
export var selected = "_s5-8";